/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { StorageUnitDownloadCredential } from '../model/storageUnitDownloadCredential';
import { StorageUnitUploadCredential } from '../model/storageUnitUploadCredential';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class StorageUnitService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * getStorageUnitDownloadCredential
     * Gets the AWS credential to download to the specified storage unit. &lt;p&gt;Requires READ permission on namespace&lt;/p&gt;
     * @param namespace the namespace
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param businessObjectFormatVersion the business object format version
     * @param partitionValue the partition value
     * @param businessObjectDataVersion the business object data version
     * @param storageName the storage name
     * @param subPartitionValues the sub-partition values
     * @param allowedSourceIpAddresses the list of allowed source IP addresses or subnets
     * @param allowedSourceVpcEndpoints the list of allowed source VPC endpoints
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storageUnitGetStorageUnitDownloadCredential(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, partitionValue: string, businessObjectDataVersion: number, storageName: string, subPartitionValues?: string, allowedSourceIpAddresses?: string, allowedSourceVpcEndpoints?: string, observe?: 'body', reportProgress?: boolean): Observable<StorageUnitDownloadCredential>;
    public storageUnitGetStorageUnitDownloadCredential(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, partitionValue: string, businessObjectDataVersion: number, storageName: string, subPartitionValues?: string, allowedSourceIpAddresses?: string, allowedSourceVpcEndpoints?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StorageUnitDownloadCredential>>;
    public storageUnitGetStorageUnitDownloadCredential(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, partitionValue: string, businessObjectDataVersion: number, storageName: string, subPartitionValues?: string, allowedSourceIpAddresses?: string, allowedSourceVpcEndpoints?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StorageUnitDownloadCredential>>;
    public storageUnitGetStorageUnitDownloadCredential(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, partitionValue: string, businessObjectDataVersion: number, storageName: string, subPartitionValues?: string, allowedSourceIpAddresses?: string, allowedSourceVpcEndpoints?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling storageUnitGetStorageUnitDownloadCredential.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling storageUnitGetStorageUnitDownloadCredential.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling storageUnitGetStorageUnitDownloadCredential.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling storageUnitGetStorageUnitDownloadCredential.');
        }
        if (businessObjectFormatVersion === null || businessObjectFormatVersion === undefined) {
            throw new Error('Required parameter businessObjectFormatVersion was null or undefined when calling storageUnitGetStorageUnitDownloadCredential.');
        }
        if (partitionValue === null || partitionValue === undefined) {
            throw new Error('Required parameter partitionValue was null or undefined when calling storageUnitGetStorageUnitDownloadCredential.');
        }
        if (businessObjectDataVersion === null || businessObjectDataVersion === undefined) {
            throw new Error('Required parameter businessObjectDataVersion was null or undefined when calling storageUnitGetStorageUnitDownloadCredential.');
        }
        if (storageName === null || storageName === undefined) {
            throw new Error('Required parameter storageName was null or undefined when calling storageUnitGetStorageUnitDownloadCredential.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (subPartitionValues !== undefined && subPartitionValues !== null) {
            queryParameters = queryParameters.set('subPartitionValues', <any>subPartitionValues);
        }
        if (allowedSourceIpAddresses !== undefined && allowedSourceIpAddresses !== null) {
            queryParameters = queryParameters.set('allowedSourceIpAddresses', <any>allowedSourceIpAddresses);
        }
        if (allowedSourceVpcEndpoints !== undefined && allowedSourceVpcEndpoints !== null) {
            queryParameters = queryParameters.set('allowedSourceVpcEndpoints', <any>allowedSourceVpcEndpoints);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<StorageUnitDownloadCredential>(`${this.configuration.basePath}/storageUnits/download/credential/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}/businessObjectFormatVersions/${encodeURIComponent(String(businessObjectFormatVersion))}/partitionValues/${encodeURIComponent(String(partitionValue))}/businessObjectDataVersions/${encodeURIComponent(String(businessObjectDataVersion))}/storageNames/${encodeURIComponent(String(storageName))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getStorageUnitUploadCredential
     * Gets the AWS credential to upload to the specified storage unit. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param namespace the namespace
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param businessObjectFormatVersion the business object format version
     * @param partitionValue the partition value
     * @param businessObjectDataVersion the business object data version
     * @param storageName the storage name
     * @param subPartitionValues the sub-partition values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storageUnitGetStorageUnitUploadCredential(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, partitionValue: string, businessObjectDataVersion: number, storageName: string, subPartitionValues?: string, observe?: 'body', reportProgress?: boolean): Observable<StorageUnitUploadCredential>;
    public storageUnitGetStorageUnitUploadCredential(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, partitionValue: string, businessObjectDataVersion: number, storageName: string, subPartitionValues?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StorageUnitUploadCredential>>;
    public storageUnitGetStorageUnitUploadCredential(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, partitionValue: string, businessObjectDataVersion: number, storageName: string, subPartitionValues?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StorageUnitUploadCredential>>;
    public storageUnitGetStorageUnitUploadCredential(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, partitionValue: string, businessObjectDataVersion: number, storageName: string, subPartitionValues?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling storageUnitGetStorageUnitUploadCredential.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling storageUnitGetStorageUnitUploadCredential.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling storageUnitGetStorageUnitUploadCredential.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling storageUnitGetStorageUnitUploadCredential.');
        }
        if (businessObjectFormatVersion === null || businessObjectFormatVersion === undefined) {
            throw new Error('Required parameter businessObjectFormatVersion was null or undefined when calling storageUnitGetStorageUnitUploadCredential.');
        }
        if (partitionValue === null || partitionValue === undefined) {
            throw new Error('Required parameter partitionValue was null or undefined when calling storageUnitGetStorageUnitUploadCredential.');
        }
        if (businessObjectDataVersion === null || businessObjectDataVersion === undefined) {
            throw new Error('Required parameter businessObjectDataVersion was null or undefined when calling storageUnitGetStorageUnitUploadCredential.');
        }
        if (storageName === null || storageName === undefined) {
            throw new Error('Required parameter storageName was null or undefined when calling storageUnitGetStorageUnitUploadCredential.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (subPartitionValues !== undefined && subPartitionValues !== null) {
            queryParameters = queryParameters.set('subPartitionValues', <any>subPartitionValues);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<StorageUnitUploadCredential>(`${this.configuration.basePath}/storageUnits/upload/credential/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}/businessObjectFormatVersions/${encodeURIComponent(String(businessObjectFormatVersion))}/partitionValues/${encodeURIComponent(String(partitionValue))}/businessObjectDataVersions/${encodeURIComponent(String(businessObjectDataVersion))}/storageNames/${encodeURIComponent(String(storageName))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
